import { render, staticRenderFns } from "./galleries.vue?vue&type=template&id=42b34840&scoped=true&"
import script from "./galleries.vue?vue&type=script&lang=js&"
export * from "./galleries.vue?vue&type=script&lang=js&"
import style0 from "./galleries.vue?vue&type=style&index=0&id=42b34840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b34840",
  null
  
)

export default component.exports